/* tslint:disable */

declare var Object: any;
export interface DeliveryCarrierInterface {
  "id"?: number;
  "name": string;
}

export class DeliveryCarrier implements DeliveryCarrierInterface {
  "id": number;
  "name": string;
  constructor(data?: DeliveryCarrierInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DeliveryCarrier`.
   */
  public static getModelName() {
    return "DeliveryCarrier";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DeliveryCarrier for dynamic purposes.
  **/
  public static factory(data: DeliveryCarrierInterface): DeliveryCarrier{
    return new DeliveryCarrier(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DeliveryCarrier',
      plural: 'DeliveryCarriers',
      path: 'DeliveryCarriers',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/DeliveryCarrier.ts